// extracted by mini-css-extract-plugin
module.exports = {"header":"ShopifyUpgrade_header__1QrcF","wrap":"ShopifyUpgrade_wrap__32liq","container":"ShopifyUpgrade_container__tV-3Q","content":"ShopifyUpgrade_content__1IYWm"};